import { makeActionCreator } from '../../config/store/utils'
import { getAgilePurchaseTradedBuyers } from '../../services/agilePurchase'

export const GET_AGILE_PURCHASE_BUYERS = 'GET_AGILE_PURCHASE_BUYERS'
export const GET_AGILE_PURCHASE_BUYERS_SUCCESS = 'GET_AGILE_PURCHASE_BUYERS_SUCCESS'
export const GET_AGILE_PURCHASE_BUYERS_ERROR = 'GET_AGILE_PURCHASE_BUYERS_ERROR'

export const onGetAgilePurchaseBuyers = makeActionCreator(GET_AGILE_PURCHASE_BUYERS)
export const onGetAgilePurchaseBuyersSuccess = makeActionCreator(GET_AGILE_PURCHASE_BUYERS_SUCCESS, 'payload')
export const onGetAgilePurchaseBuyersError = makeActionCreator(GET_AGILE_PURCHASE_BUYERS_ERROR, 'payload')

export const onGetAgilePurchaseBuyersThunk =
  ({ year, sectorsIds, sectorOptions }) =>
  async dispatch => {
    dispatch(onGetAgilePurchaseBuyers())

    try {
      const response = await getAgilePurchaseTradedBuyers({ year, sectorsIds })

      const enhancedData = response.data.payload
        .filter(item => sectorsIds.includes(item.idSector))
        .map(item => ({
          anio: item.anio,
          sector: sectorOptions.find(sectorOpt => sectorOpt.value === item.idSector)?.name,
          buyer: item.comprador,
          transactions: item.cantidad,
          amount: item.monto,
          amountUSD: item.montoUSD,
          totalQuotations: item.totalContizaciones,
          sectorId: item.idSector,
          entCode: item.entCode
        }))
        .sort((a, b) => b.amount - a.amount)

      const csv = [
        [
          'Institución',
          'Sector del Estado',
          'Cantidad de cotizaciones recibidas',
          'Monto (CLP)',
          'Monto (USD)',
          'N° de órdenes de compra'
        ],
        ...enhancedData.map(item => [
          item.buyer,
          item.sector,
          item.totalQuotations,
          item.amount,
          item.amountUSD,
          item.transactions
        ])
      ]

      dispatch(onGetAgilePurchaseBuyersSuccess({ csv, data: enhancedData }))
    } catch (error) {
      dispatch(
        onGetAgilePurchaseBuyersError({ error: error.message || 'Error al obtener datos de compradores', data: [] })
      )
    }
  }
